import { g as g$1, E, D as D$1, G, l as l$2 } from "./preact.module-B5ZnQuyU.js";
function r$1() {
  return (r$1 = Object.assign ? Object.assign.bind() : function(t2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var n = arguments[e2];
      for (var o2 in n)
        Object.prototype.hasOwnProperty.call(n, o2) && (t2[o2] = n[o2]);
    }
    return t2;
  }).apply(this, arguments);
}
var i$1 = ["context", "children"];
function a$1(t2) {
  this.getChildContext = function() {
    return t2.context;
  };
  var e2 = t2.children, n = function(t3, e3) {
    if (null == t3)
      return {};
    var n2, o2, r2 = {}, i2 = Object.keys(t3);
    for (o2 = 0; o2 < i2.length; o2++)
      e3.indexOf(n2 = i2[o2]) >= 0 || (r2[n2] = t3[n2]);
    return r2;
  }(t2, i$1);
  return G(e2, n);
}
function s$1() {
  var o2 = new CustomEvent("_preact", { detail: {}, bubbles: true, cancelable: true });
  this.dispatchEvent(o2), this._vdom = g$1(a$1, r$1({}, this._props, { context: o2.detail.context }), function e2(n, o3) {
    if (3 === n.nodeType)
      return n.data;
    if (1 !== n.nodeType)
      return null;
    var r2 = [], i2 = {}, a2 = 0, s2 = n.attributes, l2 = n.childNodes;
    for (a2 = s2.length; a2--; )
      "slot" !== s2[a2].name && (i2[s2[a2].name] = s2[a2].value, i2[c$1(s2[a2].name)] = s2[a2].value);
    for (a2 = l2.length; a2--; ) {
      var u2 = e2(l2[a2], null), d2 = l2[a2].slot;
      d2 ? i2[d2] = g$1(p$1, { name: d2 }, u2) : r2[a2] = u2;
    }
    var h2 = o3 ? g$1(p$1, null, r2) : r2;
    return g$1(o3 || n.nodeName.toLowerCase(), i2, h2);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? E : D$1)(this._vdom, this._root);
}
function c$1(t2) {
  return t2.replace(/-(\w)/g, function(t3, e2) {
    return e2 ? e2.toUpperCase() : "";
  });
}
function l$1(t2, e2, r2) {
  if (this._vdom) {
    var i2 = {};
    i2[t2] = r2 = null == r2 ? void 0 : r2, i2[c$1(t2)] = r2, this._vdom = G(this._vdom, i2), D$1(this._vdom, this._root);
  }
}
function u$1() {
  D$1(this._vdom = null, this._root);
}
function p$1(e2, n) {
  var o2 = this;
  return g$1("slot", r$1({}, e2, { ref: function(t2) {
    t2 ? (o2.ref = t2, o2._listener || (o2._listener = function(t3) {
      t3.stopPropagation(), t3.detail.context = n;
    }, t2.addEventListener("_preact", o2._listener))) : o2.ref.removeEventListener("_preact", o2._listener);
  } }));
}
function register(t2, e2, n, o2) {
  function r2() {
    var e3 = Reflect.construct(HTMLElement, [], r2);
    return e3._vdomComponent = t2, e3._root = e3, e3;
  }
  return (r2.prototype = Object.create(HTMLElement.prototype)).constructor = r2, r2.prototype.connectedCallback = s$1, r2.prototype.attributeChangedCallback = l$1, r2.prototype.disconnectedCallback = u$1, n = n || t2.observedAttributes || Object.keys(t2.propTypes || {}), r2.observedAttributes = n, n.forEach(function(t3) {
    Object.defineProperty(r2.prototype, t3, { get: function() {
      return this._vdom.props[t3];
    }, set: function(e3) {
      this._vdom ? this.attributeChangedCallback(t3, null, e3) : (this._props || (this._props = {}), this._props[t3] = e3, this.connectedCallback());
      var n2 = typeof e3;
      null != e3 && "string" !== n2 && "boolean" !== n2 && "number" !== n2 || this.setAttribute(t3, e3);
    } });
  }), customElements.define(e2 || t2.tagName || t2.displayName || t2.name, r2);
}
var t, r, u, i, o = 0, f = [], c = [], e = l$2, a = e.__b, v = e.__r, l = e.diffed, m = e.__c, s = e.unmount, d = e.__;
function h(n, t2) {
  e.__h && e.__h(r, n, o || t2), o = 0;
  var u2 = r.__H || (r.__H = { __: [], __h: [] });
  return n >= u2.__.length && u2.__.push({ __V: c }), u2.__[n];
}
function p(n) {
  return o = 1, y(D, n);
}
function y(n, u2, i2) {
  var o2 = h(t++, 2);
  if (o2.t = n, !o2.__c && (o2.__ = [i2 ? i2(u2) : D(void 0, u2), function(n2) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n2);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r, !r.u)) {
    var f2 = function(n2, t2, r2) {
      if (!o2.__c.__H)
        return true;
      var u3 = o2.__c.__H.__.filter(function(n3) {
        return !!n3.__c;
      });
      if (u3.every(function(n3) {
        return !n3.__N;
      }))
        return !c2 || c2.call(this, n2, t2, r2);
      var i3 = false;
      return u3.forEach(function(n3) {
        if (n3.__N) {
          var t3 = n3.__[0];
          n3.__ = n3.__N, n3.__N = void 0, t3 !== n3.__[0] && (i3 = true);
        }
      }), !(!i3 && o2.__c.props === n2) && (!c2 || c2.call(this, n2, t2, r2));
    };
    r.u = true;
    var c2 = r.shouldComponentUpdate, e2 = r.componentWillUpdate;
    r.componentWillUpdate = function(n2, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n2, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n2, t2, r2);
    }, r.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
function _(n, u2) {
  var i2 = h(t++, 3);
  !e.__s && C(i2.__H, u2) && (i2.__ = n, i2.i = u2, r.__H.__h.push(i2));
}
function A(n, u2) {
  var i2 = h(t++, 4);
  !e.__s && C(i2.__H, u2) && (i2.__ = n, i2.i = u2, r.__h.push(i2));
}
function F(n) {
  return o = 5, q(function() {
    return { current: n };
  }, []);
}
function T(n, t2, r2) {
  o = 6, A(function() {
    return "function" == typeof n ? (n(t2()), function() {
      return n(null);
    }) : n ? (n.current = t2(), function() {
      return n.current = null;
    }) : void 0;
  }, null == r2 ? r2 : r2.concat(n));
}
function q(n, r2) {
  var u2 = h(t++, 7);
  return C(u2.__H, r2) ? (u2.__V = n(), u2.i = r2, u2.__h = n, u2.__V) : u2.__;
}
function x(n, t2) {
  return o = 8, q(function() {
    return n;
  }, t2);
}
function P(n) {
  var u2 = r.context[n.__c], i2 = h(t++, 9);
  return i2.c = n, u2 ? (null == i2.__ && (i2.__ = true, u2.sub(r)), u2.props.value) : n.__;
}
function V(n, t2) {
  e.useDebugValue && e.useDebugValue(t2 ? t2(n) : n);
}
function g() {
  var n = h(t++, 11);
  if (!n.__) {
    for (var u2 = r.__v; null !== u2 && !u2.__m && null !== u2.__; )
      u2 = u2.__;
    var i2 = u2.__m || (u2.__m = [0, 0]);
    n.__ = "P" + i2[0] + "-" + i2[1]++;
  }
  return n.__;
}
function j() {
  for (var n; n = f.shift(); )
    if (n.__P && n.__H)
      try {
        n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
      } catch (t2) {
        n.__H.__h = [], e.__e(t2, n.__v);
      }
}
e.__b = function(n) {
  r = null, a && a(n);
}, e.__ = function(n, t2) {
  n && t2.__k && t2.__k.__m && (n.__m = t2.__k.__m), d && d(n, t2);
}, e.__r = function(n) {
  v && v(n), t = 0;
  var i2 = (r = n.__c).__H;
  i2 && (u === r ? (i2.__h = [], r.__h = [], i2.__.forEach(function(n2) {
    n2.__N && (n2.__ = n2.__N), n2.__V = c, n2.__N = n2.i = void 0;
  })) : (i2.__h.forEach(z), i2.__h.forEach(B), i2.__h = [], t = 0)), u = r;
}, e.diffed = function(n) {
  l && l(n);
  var t2 = n.__c;
  t2 && t2.__H && (t2.__H.__h.length && (1 !== f.push(t2) && i === e.requestAnimationFrame || ((i = e.requestAnimationFrame) || w)(j)), t2.__H.__.forEach(function(n2) {
    n2.i && (n2.__H = n2.i), n2.__V !== c && (n2.__ = n2.__V), n2.i = void 0, n2.__V = c;
  })), u = r = null;
}, e.__c = function(n, t2) {
  t2.some(function(n2) {
    try {
      n2.__h.forEach(z), n2.__h = n2.__h.filter(function(n3) {
        return !n3.__ || B(n3);
      });
    } catch (r2) {
      t2.some(function(n3) {
        n3.__h && (n3.__h = []);
      }), t2 = [], e.__e(r2, n2.__v);
    }
  }), m && m(n, t2);
}, e.unmount = function(n) {
  s && s(n);
  var t2, r2 = n.__c;
  r2 && r2.__H && (r2.__H.__.forEach(function(n2) {
    try {
      z(n2);
    } catch (n3) {
      t2 = n3;
    }
  }), r2.__H = void 0, t2 && e.__e(t2, r2.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n) {
  var t2, r2 = function() {
    clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n);
  }, u2 = setTimeout(r2, 100);
  k && (t2 = requestAnimationFrame(r2));
}
function z(n) {
  var t2 = r, u2 = n.__c;
  "function" == typeof u2 && (n.__c = void 0, u2()), r = t2;
}
function B(n) {
  var t2 = r;
  n.__c = n.__(), r = t2;
}
function C(n, t2) {
  return !n || n.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n[r2];
  });
}
function D(n, t2) {
  return "function" == typeof t2 ? t2(n) : t2;
}
export {
  A,
  F,
  P,
  T,
  V,
  _,
  g,
  p,
  q,
  register as r,
  x,
  y
};
